
import { z } from "zod";

export const locationSchema = z.object({
  country: z.string().min(1, { message: "Country is required" }),
  region: z.string().optional(),
  city: z.string().optional(),
});

export type LocationFormValues = z.infer<typeof locationSchema>;
